<div class="main-content-container">
    <router-outlet></router-outlet>
</div>
<div id="loader-overlay">
  <div class="loader">
  </div>
</div>